import React, { useState } from "react";
import { allFrames } from "../../frameHelper";
import { TextInput } from "../Common";
import { AutoCompletePickProps, AutoCompleteProps } from "../types";

/** Get frame name without animation suffixes (e.g: "owl_white_0" to "owl_white_") */
const getBaseFrameName = (label: string) => label.replace(/(\d+)$/, "");

/** Get frame name without underscores (e.g: "owl_white_" to "owl white") */
const cleanFrameName = (label: string) => label.replace(/_/g, " ").trim();

/** Get unique strings in an array. Emphasis on using strings (primitive value) */
const unique = (labels: string[]) => Array.from(new Set(labels));

function AutoCompletePick(props: AutoCompletePickProps) {
  const { frameName, setFrame } = props;
  return (
    <div
      className="autocomplete-choice"
      role="button"
      key={frameName}
      onClick={() => setFrame(frameName)}
      onKeyDown={e => (e.key === "Enter" ? setFrame(frameName) : null)}
      tabIndex={0}
    >
      {cleanFrameName(frameName)}
    </div>
  );
}

function useSuggestions(allSuggestions: string[]) {
  const [pick, setPick] = useState("");
  const suggestions = unique(
    allSuggestions.filter(aFrame => aFrame.includes(pick))
  );

  // we wish to autocomplete when suggestions are reasonable small
  // and the pick is not an exact match
  const enabled = suggestions.length < 20 && !suggestions.includes(pick);

  return { pick, setPick, suggestions, enabled };
}

export default function AutoComplete(props: AutoCompleteProps) {
  const { onFound } = props;
  const { pick, setPick, enabled, suggestions } = useSuggestions(
    allFrames.map(aFrame => getBaseFrameName(aFrame))
  );
  // triggered when a match is found an autocomplete has sucessfully finished
  const setFrame = (newFrameName: string) => {
    onFound(newFrameName);
    setPick(newFrameName);
  };
  return (
    <div className="autocomplete">
      <TextInput setText={setPick} text={pick} />
      <div className="autocomplete-choice-container">
        {enabled &&
          suggestions.map(frameName => (
            <AutoCompletePick
              frameName={frameName}
              setFrame={setFrame}
              key={frameName}
            />
          ))}
      </div>
    </div>
  );
}
